import { render, staticRenderFns } from "./priceInfo.vue?vue&type=template&id=7cbf1854&scoped=true&"
import script from "./priceInfo.vue?vue&type=script&lang=js&"
export * from "./priceInfo.vue?vue&type=script&lang=js&"
import style0 from "./priceInfo.vue?vue&type=style&index=0&id=7cbf1854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbf1854",
  null
  
)

export default component.exports